var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{class:'p cta ' + _vm.color,attrs:{"to":_vm.to}},[_vm._t("default"),_vm._v(" "),_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":{ prefix: 'fa', iconName: 'arrow-right' }}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }